import Paragraph from "antd/es/typography/Paragraph";
import {Modal, Radio, Form, Input} from "antd";
import React, {useEffect} from "react";
import {getFileWithoutExtension} from "../../../../../../utils/file.utils";
import {Spacer} from "../../../../../../components/DesignSystem/Spacer/Spacer";


export const SaveDialog = ({filename, format, visible, onCancel, onOk}) => {

    const options = [
        {label: 'CSV', value: 'csv'},
        {label: 'Excel', value: 'xlsx'},
        {label: 'Parquet', value: 'parquet'},
        {label: 'TSV', value: 'tsv'},
        {label: 'Json', value: 'json'},
    ];

    const [form] = Form.useForm();
    const [loading, setLoading] = React.useState(false);

    const handleOk = () => {
        setLoading(true);
        const format = form.getFieldValue("format");
        const filename = form.getFieldValue("filename");
        onOk(format, filename + '.' + format);
    }

    useEffect(() => {
        form.setFieldsValue({filename: getFileWithoutExtension(filename), format: format});
    }, [filename, format]);

    return <Modal title="Save data to file" open={visible} onCancel={onCancel}
                  centered
                  onOk={handleOk} okText={"Save"} cancelText="Cancel" confirmLoading={loading}>
        <Spacer/>
        <Form layout="vertical" form={form} labelCol={{span: 16}}
              wrapperCol={{span: 20}}>
            <Form.Item name="filename" label="File name" rules={[{required: true, message: 'Please enter a file name'}]}>
                <Input placeholder="Enter file name"/>
            </Form.Item>
            <Form.Item name="format" label="File format">
                <Radio.Group
                    options={options}
                    optionType="button"
                    buttonStyle="solid"
                />
            </Form.Item>
        </Form>
        <Spacer border={true}/>
    </Modal>

}